import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';

// Recordings live in the Space as v/<code>.mp4 (.webm for some older
// tutorials), so the short code in the link is all the page needs: there is
// no API call and no table behind it.
const VIDEO_BASE_URL = 'https://dezshop.fra1.cdn.digitaloceanspaces.com/v';
const VIDEO_CODE_PATTERN = /^[a-z0-9]{6,16}$/;
const PLAYBACK_RATES = [1, 1.25, 1.5, 2];

// Public video page (c.dezshop.ro/v/:code): the short link for a screen
// recording or a staff tutorial.
export default function VideoPage() {
  const { code } = useParams();
  const videoRef = useRef(null);
  const [rate, setRate] = useState(1);
  const [missing, setMissing] = useState(false);

  const changeRate = (nextRate) => {
    setRate(nextRate);
    if (videoRef.current) videoRef.current.playbackRate = nextRate;
  };

  if (!VIDEO_CODE_PATTERN.test(code || '') || missing) {
    return (
      <div className="mx-auto max-w-lg px-4 py-16 text-center">
        <h1 className="text-xl font-semibold text-gray-800">Videoclipul nu a fost găsit</h1>
        <p className="mt-2 text-sm text-gray-600">Verifică linkul primit sau cere unul nou.</p>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-[1100px] px-3 py-4 sm:px-6">
      <video
        ref={videoRef}
        controls
        playsInline
        preload="metadata"
        className="max-h-[calc(100vh-8.5rem)] w-full rounded-lg bg-black"
      >
        <source src={`${VIDEO_BASE_URL}/${code}.mp4`} type="video/mp4" />
        {/* The last source failing means neither file exists. */}
        <source src={`${VIDEO_BASE_URL}/${code}.webm`} type="video/webm" onError={() => setMissing(true)} />
      </video>
      <div className="mt-3 flex items-center gap-2">
        <span className="text-sm text-gray-600">Viteză</span>
        {PLAYBACK_RATES.map((option) => (
          <Button
            key={option}
            size="sm"
            variant={option === rate ? 'default' : 'outline'}
            onClick={() => changeRate(option)}
          >
            {option}×
          </Button>
        ))}
      </div>
    </div>
  );
}
